// extracted by mini-css-extract-plugin
export default {"progressIndicatorIcon":"fdx6BJzk4M1it4bW5EEv"};